var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { UserService } from "~/services/management-service/user.service";
import { Dependencies } from "~/core/decorator";
import { CarManageService } from "~/services/domain-service/car-manage.service";
var ChangeInfo = /** @class */ (function (_super) {
    __extends(ChangeInfo, _super);
    function ChangeInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            deptId: '',
            applyId: ''
        };
        _this.userList = [];
        _this.rules = {
            deptId: { required: true, type: 'array', message: '请选择归属机构' },
            applyId: { required: true, message: '请选择归属人' }
        };
        _this.loading = false;
        return _this;
    }
    ChangeInfo.prototype.emitClose = function () {
        this.reset();
    };
    ChangeInfo.prototype.handleChange = function (val) {
        var _this = this;
        this.dataForm.applyId = '';
        var obj = this.departmentList.find(function (v) { return v.id === val[val.length - 1]; });
        this.userService
            .getAllUsersList({ deptCode: obj.deptCode })
            .subscribe(function (data) {
            _this.userList = data;
        });
    };
    ChangeInfo.prototype.commit = function () {
        var _this = this;
        var from = this.$refs['dataForm'];
        from.validate(function (valid) {
            if (!valid)
                return;
            var ids = _this.selectionList.map(function (v) { return v.id; });
            var deptId = _this.dataForm.deptId[_this.dataForm.deptId.length - 1];
            var applyId = _this.dataForm.applyId;
            _this.carManageService.updateApplyUserInfo({ ids: ids, deptId: deptId, applyId: applyId }).subscribe(function (data) {
                _this.emitClose();
                _this.loading = false;
                if (!data) {
                    _this.$message.success("非归C结清案件不能变更归属人！");
                }
            }, function (error) { _this.loading = false; });
        });
    };
    ChangeInfo.prototype.reset = function () {
        var from = this.$refs['dataForm'];
        from.resetFields();
    };
    __decorate([
        Dependencies(UserService)
    ], ChangeInfo.prototype, "userService", void 0);
    __decorate([
        Dependencies(CarManageService)
    ], ChangeInfo.prototype, "carManageService", void 0);
    __decorate([
        Prop()
    ], ChangeInfo.prototype, "selectionList", void 0);
    __decorate([
        Getter
    ], ChangeInfo.prototype, "departmentData", void 0);
    __decorate([
        State
    ], ChangeInfo.prototype, "departmentList", void 0);
    __decorate([
        Emit('close')
    ], ChangeInfo.prototype, "emitClose", null);
    ChangeInfo = __decorate([
        Component({
            components: {}
        })
    ], ChangeInfo);
    return ChangeInfo;
}(Vue));
export default ChangeInfo;
